import { useState } from "react";
import { Button } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";

const ResetPassword = () => {
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");
    const { token } = useParams();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        const response = await fetch("https://api-ft5g.onrender.com/reset-password", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ token, password }),
        });

        const data = await response.text();
        setMessage(data);
        if (data === "Password reset successful") setTimeout(() => navigate("/login"), 2000);
    };

    return (
        <div>
            <h2 className="text-center">Reset Password</h2>
            <form onSubmit={handleSubmit}>
                <input className="me-3 mt-2" type="password" placeholder="New Password" value={password} onChange={e => setPassword(e.target.value)} required />
                <Button type="submit">Reset Password</Button>
            </form>
            <p className="text-center">{message}</p>
        </div>
    );
};

export default ResetPassword;